module.exports = __webpack_public_path__ + "img/logo-landscape.18e0ae3a.png";